module.exports = __webpack_public_path__ + "static/scientist13-fbccbf9c509e99af1317709161c5aceb.jpg";